export { default, ICON_ANCHOR, ICON_POSITION } from './CenteredWithIcon';

export type { CenteredWithIconType } from './CenteredWithIcon';
